{
  const root = () => window.Shopify?.routes?.root || '/';

  const applyCount = (count) => {
    document.querySelectorAll('cart-count').forEach((el) => {
      const srLabel = el.querySelector('.sr-only');
      const visibleCount = el.querySelector('[aria-hidden="true"]');
      if (srLabel || visibleCount) {
        if (srLabel) srLabel.textContent = `${count} items`;
        if (visibleCount) visibleCount.textContent = count;
      } else {
        // theme.js collapses the element to a bare text node; keep it working
        el.textContent = count;
      }
      el.classList.toggle('opacity-0', count === 0);
      el.style.opacity = count === 0 ? '0' : '1';
    });
  };

  const refreshCartCount = async () => {
    try {
      const cart = await (await fetch(`${root()}cart.js`, { cache: 'no-store' })).json();
      applyCount(cart.item_count);
    } catch {
      /* ignore network errors */
    }
  };

  const refreshCartDrawer = async () => {
    const current = document.querySelector('#cart-drawer');
    const sectionId = current?.closest('.shopify-section')?.id.replace('shopify-section-', '');
    if (!sectionId) return;
    try {
      const html = await (await fetch(`${root()}?section_id=${sectionId}`, { cache: 'no-store' })).text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#cart-drawer');
      if (fresh) current.replaceChildren(...fresh.children);
    } catch {
      /* ignore network errors */
    }
  };

  window.addEventListener('pageshow', () => {
    refreshCartCount();
    refreshCartDrawer();
    setTimeout(refreshCartCount, 600);
  });
}
